export const aoi_tax_fields = ["brena"];
